"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gradientX = gradientX;
exports.gradientY = gradientY;
exports.gradientDirectional = gradientDirectional;
exports.gradientXThreeColors = gradientXThreeColors;
exports.gradientYThreeColors = gradientYThreeColors;
exports.gradientRadial = gradientRadial;
exports.gradientStriped = gradientStriped;
exports.default = void 0;

/**
 * @public
 * @description Horizontal gradient, from left to right.
 * @param {string} startColor
 * @param {string} endColor
 * @param {string} startPercent
 * @param {string} endPercent
 * @returns {string}
 */
function gradientX() {
  var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#555';
  var endColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#333';
  var startPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0%';
  var endPercent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '100%';
  return "\n    background-image: linear-gradient(to right, ".concat(startColor, " ").concat(startPercent, ", ").concat(endColor, " ").concat(endPercent, ");\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#{ie-hex-str(").concat(startColor, ")}', endColorstr='#{ie-hex-str(").concat(endColor, ")}', GradientType=1); // IE9\n  ");
}
/**
 * @public
 * @description Vertical gradient, from top to bottom.
 * @param {string} startColor
 * @param {string} endColor
 * @param {string} startPercent
 * @param {string} endPercent
 * @returns {string}
 */


function gradientY() {
  var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#555';
  var endColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#333';
  var startPercent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0%';
  var endPercent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '100%';
  return "\n    background-image: linear-gradient(to bottom, ".concat(startColor, " ").concat(startPercent, ", ").concat(endColor, " ").concat(endPercent, ");\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#{ie-hex-str(").concat(startColor, ")}', endColorstr='#{ie-hex-str(").concat(endColor, ")}', GradientType=0); // IE9\n  ");
}
/**
 * @public
 * @description Directional gradient.
 * @param {string} startColor
 * @param {string} endColor
 * @param {string} deg
 * @returns {string}
 */


function gradientDirectional() {
  var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#555';
  var endColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#333';
  var deg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '45deg';
  return "\n    background-repeat: repeat-x;\n    background-image: linear-gradient(".concat(deg, ", ").concat(startColor, ", ").concat(endColor, ");\n  ");
}
/**
 * @public
 * @description Three colours gradient.
 * @param {string} startColor
 * @param {string} midColor
 * @param {string} colorStop
 * @param {string} endColor
 * @returns {string}
 */


function gradientXThreeColors() {
  var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#00b3ee';
  var midColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#7a43b6';
  var colorStop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '50%';
  var endColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#c3325f';
  return "\n    background-image: linear-gradient(to right, ".concat(startColor, ", ").concat(midColor, " ").concat(colorStop, ", ").concat(endColor, ");\n    background-repeat: no-repeat;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#{ie-hex-str(").concat(startColor, ")}', endColorstr='#{ie-hex-str(").concat(endColor, ")}', GradientType=1); // IE9 gets no color-stop at all for proper fallback\n  ");
}
/**
 * @public
 * @description Vertical three colours gradient.
 * @param {string} startColor
 * @param {string} midColor
 * @param {string} colorStop
 * @param {string} endColor
 * @returns {string}
 */


function gradientYThreeColors() {
  var startColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#00b3ee';
  var midColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#7a43b6';
  var colorStop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '50%';
  var endColor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '#c3325f';
  return "\n    background-image: linear-gradient(".concat(startColor, ", ").concat(midColor, " ").concat(colorStop, ", ").concat(endColor, ");\n    background-repeat: no-repeat;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#{ie-hex-str(").concat(startColor, ")}', endColorstr='#{ie-hex-str(").concat(endColor, ")}', GradientType=0); // IE9 gets no color-stop at all for proper fallback\n  ");
}
/**
 * @public
 * @description Radial gradient.
 * @param {string} innerColor
 * @param {string} outerColor
 * @returns {string}
 */


function gradientRadial() {
  var innerColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#555';
  var outerColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#333';
  return "\n    background-image: radial-gradient(circle, ".concat(innerColor, ", ").concat(outerColor, ");\n    background-repeat: no-repeat;\n  ");
}
/**
 * @public
 * @description Striped angled gradient.
 * @param {string} color
 * @param {string} angle
 * @returns {string}
 */


function gradientStriped() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'rgba(255,255,255,.15)';
  var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '45deg';
  return "\n    background-image: linear-gradient(".concat(angle, ", ").concat(color, " 25%, transparent 25%, transparent 50%, ").concat(color, " 50%, ").concat(color, " 75%, transparent 75%, transparent);\n  ");
}

var _default = {
  x: gradientX,
  y: gradientY,
  directional: gradientDirectional,
  xThreeColors: gradientXThreeColors,
  yThreeColors: gradientYThreeColors,
  radial: gradientRadial,
  striped: gradientStriped
};
exports.default = _default;